export const STATUS = [
    {
        value: 'ACTIVE',
        viewValue: 'ACTIVE',
    },
    {
        value: 'INACTIVE',
        viewValue: 'INACTIVE',
    },
];

export const CENTER_SORTING_TYPES = [
    {
        value: 'CITY',
        viewValue: 'City Sorting',
    },
    {
        value: 'CENTRE',
        viewValue: 'Centre sorting',
    },
];

export const Status = [
    {
        value: 'Active',
        viewValue: 'Active',
    },
    {
        value: 'Inactive',
        viewValue: 'Inactive',
    },
];

export const RESULT_TYPE = [
    {
        value: 'SCHEDULE',
        viewValue: 'Schedule',
    },
    {
        value: 'INTERVAL',
        viewValue: 'Interval',
    },
];

export const MODE_TYPE = [
    {
        value: 'Both',
        viewValue: 'Combined Calculation',
    },
    {
        value: 'Online/Offline',
        viewValue: 'Separate  Calculation',
    },
];

export const MODE = [
    {
        value: 'Online',
        viewValue: 'Online',
    },
    {
        value: 'Offline',
        viewValue: 'Offline',
    },
];

export const INTERVIEW_MODE = [
    {
        value: 'ONLINE',
        viewValue: 'Online',
    },
    {
        value: 'OFFLINE',
        viewValue: 'Offline',
    },
    {
        value: 'BOTH',
        viewValue: 'Both',
    },
];

export const TYPES = [
    {
        value: 'WEB',
        viewValue: 'WEB',
    },
    {
        value: 'APP',
        viewValue: 'APP',
    },
];

export const IMAGE_CATEGORY = [
    {
        value: 'Building',
        viewValue: 'Building',
    },
    {
        value: 'Classroom',
        viewValue: 'Classroom',
    },
    {
        value: 'Reception',
        viewValue: 'Reception',
    },
    {
        value: 'Library',
        viewValue: 'Library',
    },
    {
        value: 'Doubt Centre',
        viewValue: 'Doubt Centre',
    },
];

export const SOURCE = [
    {
        value: 'WEB',
        viewValue: 'WEB',
    },
    {
        value: 'JUST_DIAL',
        viewValue: 'JUST_DIAL',
    },
    {
        value: 'REFERENCE',
        viewValue: 'REFERENCE',
    },
    {
        value: 'APP',
        viewValue: 'APP',
    },
    {
        value: 'OFFLINE_PROMOTION',
        viewValue: 'OFFLINE_PROMOTION',
    },
    {
        value: 'ONLINE_PROMOTION',
        viewValue: 'ONLINE_PROMOTION',
    },
    {
        value: 'TEACHER_REFERRAL',
        viewValue: 'TEACHER_REFERRAL',
    },
    {
        value: 'STUDENT_REFERRAL',
        viewValue: 'STUDENT_REFERRAL',
    },
];

export const PLATFORMS = [
    {
        value: 'android',
        viewValue: 'Android',
    },
    {
        value: 'ios',
        viewValue: 'iOS',
    },
    {
        value: 'web',
        viewValue: 'Web',
    },
];

export const IMAGE_TYPES = [
    {
        value: 'Web',
        viewValue: 'WEB',
    },
    {
        value: 'App',
        viewValue: 'APP',
    },
];

export const PW_EDUCATION_PLATFORMS = [
    {
        value: 'Vidyapeeth',
        viewValue: 'Vidyapeeth',
    },
    {
        value: 'VP-RP',
        viewValue: 'VP-RP',
    },
    {
        value: 'VP Live',
        viewValue: 'VP Live',
    },
    {
        value: 'MIP',
        viewValue: 'MIP',
    },
    {
        value: 'Pathshala',
        viewValue: 'Pathshala',
    },
    {
        value: 'VP Digital',
        viewValue: 'VP Digital',
    },
    {
        value: 'Home Tuition',
        viewValue: 'Home Tuition',
    },
    {
        value: 'AITS',
        viewValue: 'AITS',
    },
    {
        value: 'Fastrack',
        viewValue: 'Fastrack',
    },
];

export const XYLEM_EDUCATION_PLATFORMS = [
    {
        value: 'Hybrid Centers',
        viewValue: 'Hybrid Centers',
    },
    {
        value: 'Tuition Centers',
        viewValue: 'Tuition Centers',
    },
    {
        value: 'Integrated Schools',
        viewValue: 'Integrated Schools',
    },
    {
        value: 'Crash Course',
        viewValue: 'Crash Course',
    },
];

export const THEME = [
    {
        value: 'vp_theme',
        viewValue: 'Red theme',
    },
    {
        value: 'info_theme',
        viewValue: 'Blue Theme',
    },
    {
        value: 'link_theme',
        viewValue: 'Teal Blue Theme',
    },
    {
        value: 'success_theme',
        viewValue: 'Green Theme',
    },
    {
        value: 'warning_theme',
        viewValue: 'Yellow Theme',
    },
];

export const AVAILABLE_FOR = [
    {
        value: 'WEB',
        viewValue: 'WEB',
    },
    {
        value: 'MOBILE',
        viewValue: 'MOBILE',
    },
];

export enum ImageCategory {
    Building = 'Building',
    Classroom = 'Classroom',
    Reception = 'Reception',
    Library = 'Library',
    DoubtCentre = 'Doubt Centre',
}

export const ACTIONS = [
    {
        value: 'Open',
        viewValue: 'Open',
    },
    {
        value: 'Download',
        viewValue: 'Download',
    },
    {
        value: 'Print',
        viewValue: 'Print',
    },
];
export const JOB_ALERT_DEVICE_TYPE = [
    {
        value: 'web',
        viewValue: 'Web',
    },
    {
        value: 'android',
        viewValue: 'Android',
    },
];

export const PW_CENTER = [
    {
        value: 'PW_VIDYAPEETH',
        viewValue: 'PW VIDYAPEETH',
    },
    {
        value: 'PW_PATHSHALA',
        viewValue: 'PW PATHSHALA',
    },
    {
        value: 'THIRD_PARTY_CENTER',
        viewValue: 'THIRD PARTY CENTER',
    },
];

export const XYLEM_CENTER = [
    {
        value: 'OFFLINE_CENTRE',
        viewValue: 'Offline Centre',
    },
];

export const YEARS = [
    '2015 or earlier',
    '2016',
    '2017',
    '2018',
    '2019',
    '2020',
    '2021',
    '2022',
    '2023',
    '2024',
    '2025',
    '2026',
    '2027',
    '2028',
    '2029',
    '2030',
];

export const SESSION_END_YEAR = [
    {
        value: '2025',
        viewValue: '2025',
    },
    {
        value: '2026',
        viewValue: '2026',
    },
    {
        value: '2027',
        viewValue: '2027',
    },
];
